import { OptionType } from 'components';

export enum TypeAttestation {
    Initial = '1', // arrêt initial
    Over6Months = '2',
}

export const optionTypeAttestation: OptionType[] = [
    { value: TypeAttestation.Initial, label: 'Arrêt initial' },
    { value: TypeAttestation.Over6Months, label: 'Arrêt de plus de 6 mois' },
];
